import React from "react";

const FortuneStatsSkeleton = () => {
  return (
    <div className="relative border w-full border-lightPrimary/40 dark:border-info/40 p-6 mx-4 my-3 rounded-md dark:bg-card-custom-radial">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-sm text-info dark:text-grey overflow-y-auto">
        <div className="space-y-4">
          {[...Array(3)].map((_, i) => (
            <div key={i}>
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-32 mb-2 animate-pulse"></div>
              <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-24 animate-pulse"></div>
            </div>
          ))}
        </div>

        <div className="flex flex-col justify-between">
          {[...Array(2)].map((_, i) =>
            i % 2 === 0 ? (
              <div
                key={`row-${i}`}
                className="flex justify-between items-center gap-4 w-fit mb-3"
              >
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20 animate-pulse"></div>
                <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-16 animate-pulse"></div>
              </div>
            ) : (
              <div key={`stack-${i}`} className="mb-3">
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-32 mb-2 animate-pulse"></div>
                <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-24 animate-pulse"></div>
              </div>
            )
          )}
        </div>

        <div className="space-y-4 w-fit">
          {[...Array(2)].map((_, i) => (
            <div
              key={i}
              className="flex justify-between items-center gap-4 w-full"
            >
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20 animate-pulse"></div>
              <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-16 animate-pulse"></div>
            </div>
          ))}
        </div>

        <div className="space-y-4 w-fit">
          {[...Array(2)].map((_, i) => (
            <div
              key={i}
              className="flex justify-between items-center gap-4 w-full"
            >
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20 animate-pulse"></div>
              <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-16 animate-pulse"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FortuneStatsSkeleton;
